import "core-js/modules/es.error.cause.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-29aba7b7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  id: "fifa-pc"
};
const _hoisted_2 = {
  key: 0,
  class: "desc"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ball"
}, null, -1));
const _hoisted_4 = {
  class: "date"
};
const _hoisted_5 = {
  key: 0,
  class: "content"
};
const _hoisted_6 = {
  class: "close"
};
import { ref, onMounted, nextTick, onBeforeUnmount } from "vue";
import { useActions } from "@/utils/map-state";
import { promoteUrl } from "@/utils/url";
import { getWorldCupDataAPI } from '@/api';
export default {
  __name: 'fifaPC',
  setup(__props) {
    let intervalId, timeoutId;
    const worldCupData = ref();
    const commonActions = useActions('common', ['closeFifaFlag']);
    const closeFifa = () => {
      document.cookie = 'showFIFA=0;path=/';
      commonActions.closeFifaFlag({
        'show': false,
        'force': false
      });
    };
    const getWorldCupData = async () => {
      try {
        const {
          head,
          body
        } = await getWorldCupDataAPI();
        const validate = [head[0], body[0]];
        if (head.errCode !== 0) {
          throw new Error(head.errMsg);
        }
        worldCupData.value = body.list.filter(item => item.is_last === 1)[0] || [];
      } catch (error) {
        console.log(error);
        worldCupData.value = [];
      }
    };
    const goFIFA = () => {
      window.location.href = promoteUrl() + '/member.php?mod=togw&gourl=fifaWorldCup2022.htm';
    };
    const fetchDataWithAdjustPostiton = async () => {
      await getWorldCupData();
      await nextTick();
      try {
        document.querySelector('#fifa-pc').style.top = `${630 - document.querySelector('#fifa-pc').getBoundingClientRect().height - 30}px`;
      } catch (error) {}
    };
    //每小時抓資料 先取剩下的時間.再執行interval (整點 + 1分重刷 ex:23:01)
    const perHourFetchData = () => {
      const leftTime = (60 - new Date().getMinutes()) * (60 * 1000) + 60000;
      timeoutId = setTimeout(() => {
        fetchDataWithAdjustPostiton();
        intervalId = setInterval(() => {
          fetchDataWithAdjustPostiton();
        }, 60 * 60 * 1000);
      }, leftTime);
    };
    onMounted(async () => {
      await fetchDataWithAdjustPostiton();
      perHourFetchData();
    });
    onBeforeUnmount(() => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    });
    return (_ctx, _cache) => {
      return worldCupData.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass([{
          'fifa-default': !worldCupData.value.title,
          'fifa': worldCupData.value.title
        }])
      }, [worldCupData.value.title ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, _toDisplayString(worldCupData.value.title.split('-')[1]) + "月" + _toDisplayString(worldCupData.value.title.split('-')[2]) + "日", 1), worldCupData.value.info ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(worldCupData.value.info.split('\n'), (content, index) => {
        return _openBlock(), _createElementBlock("span", {
          key: index
        }, _toDisplayString(content), 1);
      }), 128))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["main-icon", [{
          'main-icon-absolute': !worldCupData.value.title
        }]])
      }, null, 2), _createElementVNode("div", {
        class: "btn-go-fifa-page pointer",
        onClick: _cache[0] || (_cache[0] = $event => goFIFA())
      }, "去投注")], 2), _createElementVNode("div", _hoisted_6, [_createElementVNode("i", {
        class: "ico-close-o pointer",
        onClick: _cache[1] || (_cache[1] = $event => closeFifa())
      })])])) : _createCommentVNode("", true);
    };
  }
};